import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChangePasswordPageComponent } from './change-password.page';

const routes: Routes = [
  {
    component: ChangePasswordPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ChangePasswordPageRoutingModule {}
